export default function (context,config){
    const productData = config.json
    const products = config.appendResults ? context.state.products : []
    for(let index in productData){
        const product = productData[index]
        products.push({
            productSku: product.productSku,
            colliSize: product.colliSize,
            variantSku: product.variantSku,
            displayName: product.displayName,
            brand: product.brand,
            inStock: {
                inStock: product.inStock.inStock,
                formatted: product.inStock.formatted,
                formattedAvailableDate: product.inStock.formattedDate
            },
            price: {
                amount: product.price.amount,
                currency: product.price.currency,
                formatted: product.price.formatted,
                taxLabel: product.price.taxLabel
            },
            retailPrice:{
                amount: product.retailPrice.amount,
                currency: product.retailPrice.currency,
                formatted: product.retailPrice.formatted,
                taxLabel: product.retailPrice.taxLabel
            },
            currency: product.currency,
            colliLabel: {
                colliSize: product.colliLabel.colliSize,
                formatted: product.colliLabel.formatted
            },
            labels: product.labels,
            packShotUrls: product.packShotUrls,
            hoverShotUrls: product.hoverShotUrls,
            productPageUrl: product.productPageUrl
        })
    }
    context.commit(config.mutation,products)
    context.commit('update_search_spinner',false)

}
